import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  endTutorial,
  hideDetailTransactionModal,
  hidePaymentGatewayErrorModal,
  pageRequest,
  showDetailTransactionModal,
  startTrial,
  verifyBilling,
} from 'actions/tableManagement/tableManagementSubscription';
import FeatureTutorialPage from 'components/FeatureTutorialPage';
import FeatureBillingPage from 'components/FeatureBillingPage';
import FeatureTrialPage from 'components/FeatureTrialPage';
import FeatureBlockerPage from 'components/FeatureBlockerPage';
import MenuTitle from 'components/MenuTitle';

import TableManagementLogo from 'assets/images/ic_tablemanagement.png';
import moment from 'moment';
import * as clevertapTableManagement from 'clevertap/tableManagement';
import styles from './TableManagement.css';

const DISCOUNT_PRICE_LOWER_BOUND = 249000;

class TableManagement extends Component {
  componentDidMount() {
    const {
      trialEndAt,
      outletSlot,
      billingNotification,
      alreadySubscribed,
    } = this.props;
    this.props.dispatch(
      pageRequest(
        trialEndAt,
        outletSlot,
        billingNotification,
        alreadySubscribed
      )
    );
  }

  render() {
    const {
      isTableManagementActive,
      isOnTutorial,
      pageOnLoading,
      featureName,
      alreadySubscribed,
      featurePrice,
      currentOutletCount,
      buttonMessage,
      isButtonDisabled,
      pendingPaymentMessage,
      pendingOutletMessage,
      showDetailModal,
      outletList,
      showPaymentGatewayErrorModal,
      isOwner,
      trialDurationDays,
      isFeatureOnTrial,
    } = this.props;
    let { featurePricePerMonths, trialEndAt } = this.props;

    const featureTrial = trialDurationDays > 0;
    featurePricePerMonths = featureTrial ? 0 : featurePricePerMonths;
    trialEndAt = alreadySubscribed
      ? moment().add(trialDurationDays, 'days')
      : moment
          .min([moment().add(trialDurationDays, 'days'), moment(trialEndAt)])
          .toString();

    const youtubeVideoId = '8dpNl9Ggv28';
    const messages =
      pendingPaymentMessage !== null
        ? pendingPaymentMessage
        : pendingOutletMessage !== null
        ? pendingOutletMessage
        : null;
    return (
      <div>
        {((!pageOnLoading && !isTableManagementActive) || isOnTutorial) && (
          <MenuTitle menuTitle="Table Management" column="12" />
        )}
        <div
          className={`container container-table-management ${
            !isTableManagementActive
              ? styles['container-table-management-non-active']
              : ''
          } ${styles.container}`}
        >
          {!pageOnLoading && !isOwner && !isTableManagementActive && (
            <FeatureBlockerPage />
          )}
          {!pageOnLoading &&
            !isTableManagementActive &&
            featureTrial &&
            !isOnTutorial &&
            isOwner && (
              <FeatureTrialPage
                featureName={featureName}
                featurePricePerMonths={featurePricePerMonths}
                discountPriceLowerBound={DISCOUNT_PRICE_LOWER_BOUND}
                description="Easily replicate your restaurant table layout for increased efficiency & assign orders to tables to make meal distribution effortless."
                featureIcon={TableManagementLogo}
                startTrial={this._startTrial}
                trialEndAt={trialEndAt}
                featureVideo={`https://www.youtube.com/embed/${youtubeVideoId}`}
              />
            )}
          {!pageOnLoading &&
            !isTableManagementActive &&
            !featureTrial &&
            !isOnTutorial &&
            isOwner && (
              <FeatureBillingPage
                featureName={featureName}
                discountPriceLowerBound={DISCOUNT_PRICE_LOWER_BOUND}
                videoLink={`https://www.youtube.com/embed/${youtubeVideoId}`}
                featureMessage="Easily replicate your restaurant table layout for increased efficiency & assign orders to tables to make meal distribution effortless."
                featureLogo={TableManagementLogo}
                featurePrice={featurePrice}
                featurePricePerMonths={featurePricePerMonths}
                currentOutletCount={currentOutletCount}
                buttonMessage={buttonMessage}
                isButtonDisabled={isButtonDisabled}
                billingMessages={messages}
                showDetailModal={showDetailModal}
                onHide={this._onHide}
                onShow={this._onShow}
                outletList={outletList}
                verifyBilling={this._verifyBilling}
                showPaymentGatewayErrorModal={showPaymentGatewayErrorModal}
                hidePaymentGatewayErrorModal={
                  this._hidePaymentGatewayErrorModal
                }
              />
            )}
          {!pageOnLoading && isOnTutorial && isOwner && (
            <div className={styles['tutorial-page']}>
              <FeatureTutorialPage
                featureName={`${featureName}`}
                isSubscribedAccount={!isFeatureOnTrial && !featureTrial}
                endTutorial={this._endTutorial}
                message={`Thank you for trying Moka's Table Management Feature.`}
                videoLink={'https://www.youtube.com/embed/dG0mM87-C6U'}
              />
            </div>
          )}
          {!pageOnLoading &&
            isTableManagementActive &&
            !isOnTutorial &&
            this.props.children}
        </div>
      </div>
    );
  }

  _endTutorial = () => {
    const { isOwner } = this.props;
    if (isOwner)
      this.props.dispatch(endTutorial({ feature_name: 'Table Management' }));
  };

  _onHide = () => {
    const { isOwner } = this.props;
    if (isOwner) this.props.dispatch(hideDetailTransactionModal());
  };

  _onShow = () => {
    const { isOwner } = this.props;
    if (isOwner) this.props.dispatch(showDetailTransactionModal());
  };

  _verifyBilling = () => {
    const { featureName, featurePrice, isOwner } = this.props;
    if (isOwner) {
      const featureData = {
        type: 'FeatureBilling',
        feature_name: featureName,
        total_amount: featurePrice.final_price,
      };
      this.props.dispatch(verifyBilling(featureData));
    }
  };

  _hidePaymentGatewayErrorModal = () => {
    const { isOwner } = this.props;
    if (isOwner) this.props.dispatch(hidePaymentGatewayErrorModal());
  };

  _startTrial = () => {
    const { isOwner } = this.props;
    if (isOwner) {
      const { outletList, featurePrice } = this.props;
      clevertapTableManagement.startTrial({ outletList, featurePrice });
      this.props.dispatch(startTrial());
    }
  };
}

function mapStateToProps(state) {
  const {
    already_subscribed,
    business: { trial_end_at, outlet_slot },
    is_owner,
  } = state.moka.user;
  const {
    isOnTutorial,
    pageOnLoading,
    subscriptionDetail: { name, is_active, trial_duration_days, on_trial },
    featurePrice,
    featurePricePerMonths,
    currentOutletCount,
    isButtonDisabled,
    buttonMessage,
    pendingPaymentMessage,
    pendingOutletMessage,
    showDetailModal,
    outletList,
    showPaymentGatewayErrorModal,
  } = state.tableManagement.tableManagementSubscription;
  const { billingNotification } = state;
  return {
    alreadySubscribed: already_subscribed,
    trialEndAt: trial_end_at,
    outletSlot: outlet_slot,
    isOwner: is_owner,
    isOnTutorial,
    isTableManagementActive: is_active,
    pageOnLoading,
    featureName: name,
    featurePrice,
    featurePricePerMonths,
    currentOutletCount,
    isButtonDisabled,
    buttonMessage,
    pendingPaymentMessage,
    pendingOutletMessage,
    showDetailModal,
    outletList,
    showPaymentGatewayErrorModal,
    billingNotification,
    trialDurationDays: trial_duration_days,
    isFeatureOnTrial: on_trial,
  };
}

export default connect(mapStateToProps)(TableManagement);
